import { FC } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "@contexts/AuthContext.tsx";
import { saveReturnTo } from "@utils/auth-return-to";
import ErrorBoundary from "../common/ErrorBoundary";
import LoadingFallback from "../common/LoadingFallback";

const ProtectedRoute: FC = () => {
  const { isAuthenticated, emailVerified, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return <LoadingFallback message="Checking authentication..." />;
  }

  if (!isAuthenticated) {
    // Remember where the user was headed so we can return after login
    saveReturnTo(location.pathname + location.search + location.hash);
    return <Navigate to="/login" replace />;
  }

  if (!emailVerified) {
    return <Navigate to="/verify-email" replace />;
  }

  return (
    <ErrorBoundary>
      <Outlet />
    </ErrorBoundary>
  );
};

export default ProtectedRoute;
